module.exports = __webpack_public_path__ + "static/img/22.7873504c.gif";